import React from 'react';

import { MenuItem, TextField } from '@mui/material';

import { useGetBedbankRooms } from '~/hooks/apis/tours/useTourHotelAddOns';

interface Props {
  propertyId: string;
  value: string | null;
  onChange: (value: string | null) => void;
}

const NO_ROOM = 'none';

/** The room recommended at a bedbank property, from the rooms it offers. */
export default function NativeTourBedbankRoomSelect({ propertyId, value, onChange }: Props) {
  const { data: rooms = [], isLoading } = useGetBedbankRooms(propertyId);
  // A room picked before that the property no longer lists is kept, so it isn't lost silently.
  const options = value && !rooms.some((room) => room.id === value) ? [...rooms, { id: value, name: value }] : rooms;

  return (
    <TextField
      select
      size="small"
      label="Room"
      value={value ?? NO_ROOM}
      onChange={(event) => onChange(event.target.value === NO_ROOM ? null : event.target.value)}
      disabled={isLoading}
      sx={{ minWidth: 260 }}
    >
      <MenuItem value={NO_ROOM}>No particular room</MenuItem>
      {options.map((room) => (
        <MenuItem key={room.id} value={room.id}>
          {room.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
